import { render, staticRenderFns } from "./BusinessPurchaseSupply.vue?vue&type=template&id=6e3c9397&scoped=true"
import script from "./BusinessPurchaseSupply.vue?vue&type=script&lang=js"
export * from "./BusinessPurchaseSupply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3c9397",
  null
  
)

export default component.exports